import React from "react";
import {useHistory, withRouter} from "react-router-dom";
import Header from "./Header";
import useAiDiagnosisTestData from "../../../../hooks/useAiDiagnosisTestData";
import useLoading from "../../../../hooks/useLoading";
import { useLearningHistory } from "../../../../hooks";

const Guide1 = withRouter((props) => {
  const { setAiDiagnosisTestData } = useAiDiagnosisTestData();
  const { setLoading, clearLoading, loading } = useLoading();
  const { onLearninStartBtn} = useLearningHistory();
  const history = useHistory();

  const resetRedux = () => {
    setAiDiagnosisTestData({
        grade: '',
        year: '',
        yearLabel: '출생년도',
        month: '',
        monthLabel: '월',
        gender: ''
    });
  };

  const moveNext = () => {
    onLearninStartBtn({
      type : 'replace',
      viewPath : history.location.pathname
    });
    
    // props.history.replace({
    //   pathname: URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.AI_PREDICTION,
    // });
  };

  const onLoading = () => {
    setLoading({ isShowSpinner:true, spinnerType:'1'});
  };

  const stopLoading = () => {
    if(loading.isShowSpinner){
      clearLoading();
    }
  };

  React.useLayoutEffect(onLoading, []);
  React.useEffect(stopLoading, [loading.isShowSpinner]);
  React.useEffect(resetRedux, [] );

  return (
    <div className="layout-def layout-lc">
    <Header />
    <div className="container">
      <div className="inner">
        <div className="centermiddleBox">
          <div className="centermiddleBox-item">
            <div className="aic-intro">
              <div className="aic-intro-item">
                <h2 className="tit">안녕하세요!</h2>
              </div>

              <div className="aic-intro-item">
                <p className="txt-normal txt-gray">
                  웅진 AI 진단테스트는 다년간 누적된 수백만 학습자의<br/>
                  문제풀이 데이터를 기반으로 진행됩니다.
                </p>
              </div>

              <div className="aic-intro-item">
                <div className="imgBox">
                  <img src={ `${ process.env.PUBLIC_URL }/static/images/common/img_lc_02_02_mo.png`} alt=""/>
                </div>
              </div>

              <div className="aic-intro-item">
                <div className="btmTxt-skyBox">
                  <p className="txt-bigger txt-sky">
                    20~25문제만 풀어도 학습 시작점을 정확하게 파악하여<br/>
                    개인별로 완전히 다른 코스학습을 제공합니다.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="footer">
      <div className="footer-inner">
        <button className="btn btn-blue" onClick={moveNext}>다음</button>
      </div>
    </div>
    </div>
  );

});

export default Guide1;
